import { CalendarEvent } from '../../types/calendar/calendarTypes';
import {
    IContractListFiltersState,
    IContractListState,
} from '../../types/contracts/contractTypes';
import {
    defaultFilterTypes,
    headerColumnTypes,
    sortDirections,
} from '../../types/lists/listTypes';

export const getContractsInitialStateFilters = (
    timezone: string
): IContractListFiltersState => ({
    Name: {
        filterType: defaultFilterTypes.DEFAULT_STRING_FILTER_TYPE,
        filterKey: 'Name',
        value: '',
    },
    IdSupplierHotel: {
        value: null,
        filterType: defaultFilterTypes.DEFAULT_INTEGER_ID_FILTER_TYPE,
        filterKey: 'IdSupplierHotel',
    },
    IdStaticRateContractStatusType: {
        value: null,
        filterType: defaultFilterTypes.DEFAULT_INTEGER_ID_FILTER_TYPE,
        filterKey: 'IdStaticRateContractStatusType',
    },
    IdAgency: {
        value: null,
        filterType: defaultFilterTypes.DEFAULT_INTEGER_ID_FILTER_TYPE,
        filterKey: 'IdAgency',
    },
    ActiveFrom: {
        value: null,
        filterType: defaultFilterTypes.DEFAULT_DATE_TIME_FROM_FILTER_TYPE,
        filterKey: 'ActiveFrom',
        timeZone: timezone,
    },
    ActiveTo: {
        value: null,
        filterType: defaultFilterTypes.DEFAULT_DATE_TIME_TO_FILTER_TYPE,
        filterKey: 'ActiveTo',
        timeZone: timezone,
    },
});

export const contractsTableColumns = [
    {
        id: 'Enabled',
        labelText: 'enabled',
        titleText: 'enabled',
    },
    {
        id: 'StaticRateContractStatus/IdStaticRateContractStatusType',
        labelText: 'status',
        titleText: 'status',
    },
    {
        id: 'Name',
        labelText: 'name',
        titleText: 'name',
        columnType: headerColumnTypes.SORTABLE,
        sortableProps: {
            sortKey: 'Name',
            defaultSortDir: sortDirections.ASC,
        },
    },

    {
        id: 'SupplierHotel/Name',
        labelText: 'hotel',
        titleText: 'hotel',
        columnType: headerColumnTypes.SORTABLE,
        sortableProps: {
            sortKey: 'SupplierHotel/Name',
            defaultSortDir: sortDirections.ASC,
        },
    },
    {
        id: 'Agency/Name',
        labelText: 'agency',
        titleText: 'agency',
        columnType: headerColumnTypes.SORTABLE,
        sortableProps: {
            sortKey: 'Agency/Name',
            defaultSortDir: sortDirections.ASC,
        },
    },
    {
        id: 'Type',
        labelText: 'rate_scope_model',
        titleText: 'rate_scope_model',
    },
    {
        id: 'ActiveFrom',
        labelText: 'dates',
        titleText: 'dates',
    },
];

export const contractsSortableColumns = [
    {
        columnId: 'Name',
        sortKey: 'Name',
        defaultSortDir: sortDirections.ASC,
    },
    {
        columnId: 'SupplierHotel/Name',
        sortKey: 'SupplierHotel/Name',
        defaultSortDir: sortDirections.ASC,
    },
    {
        columnId: 'Agency/Name',
        sortKey: 'Agency/Name',
        defaultSortDir: sortDirections.ASC,
    },
] as const;

export const CONTRACTS_FILTERS_INITIAL_STATE = [
    {
        field: 'Name',
        filterType: defaultFilterTypes.DEFAULT_STRING_FILTER_TYPE,
        filterKey: 'Name',
    },
    {
        field: 'IdSupplierHotel',
        filterType: defaultFilterTypes.DEFAULT_INTEGER_ID_FILTER_TYPE,
        filterKey: 'IdSupplierHotel',
    },
    {
        field: 'IdStaticRateContractStatusType',
        filterType: defaultFilterTypes.DEFAULT_INTEGER_ID_FILTER_TYPE,
        filterKey: 'IdStaticRateContractStatusType',
    },
    {
        field: 'IdAgency',
        filterType: defaultFilterTypes.DEFAULT_INTEGER_ID_FILTER_TYPE,
        filterKey: 'IdAgency',
    },
    {
        field: 'ActiveFrom',
        filterType: defaultFilterTypes.DEFAULT_DATE_TIME_FROM_FILTER_TYPE,
        filterKey: 'ActiveFrom',
    },
    {
        field: 'ActiveTo',
        filterType: defaultFilterTypes.DEFAULT_DATE_TIME_TO_FILTER_TYPE,
        filterKey: 'ActiveTo',
    },
] as const;

export const contractsCardsVisibleFields = [
    'Enabled',
    'StaticRateContractStatusType',
    'Name',
    'SupplierHotel',
    'Agency',
    'SupplierHotelRatePlan',
    'RateScopeModel',
    'ActiveFrom',
    'ActiveTo',
] as const;

export const buildContractsCalendarEvents = (
    items: IContractListState[]
): CalendarEvent<IContractListState>[] => {
    return items.map(item => ({
        id: item.Id,
        title: String(item.Name || ''),
        start: item.ActiveFrom,
        end: item.ActiveTo,
        allDay: true,
        extendedProps: item,
    }));
};
